import { MmDialogSize } from '@metromarkets/components';

const panelClass = 'adyen-3ds-modal__panel';

export const ADYEN_3DS_MODAL_OPTIONS_CHALLENGE_FLOW = {
  panelClass,
  backdropClass: 'adyen-3ds-modal__backdrop',
  dialogSize: MmDialogSize.fit,
  backdropDisableClose: true,
  dialogHasOffsets: false,
};

export const ADYEN_3DS_MODAL_OPTIONS_NO_CHALLENGE_FLOW = {
  panelClass,
  hasBackdrop: false,
  width: '0',
  height: '0',
};
